import { PageLink } from 'assets/layout/core'

export const breadcrumbList: PageLink[] = [
  {
    title: 'Contratações',
    path: '/commercial/contracts',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
